/**
 * BugMail SDK - Main entry point
 * Captures and reports JavaScript errors to BugMail backend
 */

import BugMailClient from './bugmail-client';
import { version } from '../package.json';

// Export the actual client class as the default so `import BugMail from '@bugmail-js/sdk'`
// returns a constructor (backwards compatible with README examples)
export { BugMailClient };
export { version };
export default BugMailClient;

// Auto-initialize if in browser environment with global script
if (typeof window !== 'undefined') {
    // Look for configuration in global scope or data attributes
    const config = window.BUGMAIL_CONFIG || {};

    // Initialize if API key is available
    if (config.apiKey) {
        // Create a global instance for CDN consumers
        window.bugmail = new BugMailClient(config);
        console.log(`BugMail SDK (v${version}) initialized successfully`);
    } else {
        console.warn('BugMail SDK not initialized: Missing API key');
    }
}
